import { render, staticRenderFns } from "./HomeHospital.vue?vue&type=template&id=c2495a2e&scoped=true"
import script from "./HomeHospital.vue?vue&type=script&lang=js"
export * from "./HomeHospital.vue?vue&type=script&lang=js"
import style0 from "./HomeHospital.vue?vue&type=style&index=0&id=c2495a2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2495a2e",
  null
  
)

export default component.exports